import { RouteConfig } from 'vue-router';

const jobs: RouteConfig = {
  path: '/jobs',
  component: () => import('../views/jobs/jobs.vue'),
  meta: {
    title: '数据开发中心'
  },
  children: [
    {
      path: '/jobs/all',
      meta: {
        title: '作业调度总览'
      },
      component: () => import('../views/jobs/pages/all/all.vue')
    },
    {
      path: '/jobs/rule',
      meta: {
        title: '决策分析作业'
      },
      component: () => import('../views/jobs/pages/job/rule.vue')
    },
    {
      path: '/jobs/ind',
      meta: {
        title: '指标固化作业'
      },
      component: () => import('../views/jobs/pages/job/ind.vue')
    },
    {
      path: '/jobs/sub',
      meta: {
        title: '主题同步作业'
      },
      component: () => import('../views/jobs/pages/job/sub.vue')
    },
    {
      path: '/jobs/dim',
      meta: {
        title: '维表同步作业'
      },
      component: () => import('../views/jobs/pages/job/dim.vue')
    },
    {
      path: '/jobs/sys',
      meta: {
        title: '系统运维作业'
      },
      component: () => import('../views/jobs/pages/job/sys.vue')
    },
    {
      path: '/jobs/monitor',
      meta: {
        title: '财务监管作业'
      },
      component: () => import('../views/jobs/pages/job/monitor.vue')
    },
    {
      path: '/jobs/data',
      meta: {
        title: '数据管理作业'
      },
      component: () => import('../views/jobs/pages/job/data.vue')
    },
    {
      path: '/jobs/record',
      redirect: '/jobs'
    },
    {
      path: '/jobs/record/total',
      meta: {
        title: '作业运行总览'
      },
      component: () => import('../views/jobs/pages/record/total.vue')
    },
    {
      path: '/jobs/record/group',
      meta: {
        title: '作业类型运行总览'
      },
      component: () => import('../views/jobs/pages/record/group.vue')
    },
    {
      path: '/jobs/record/rule',
      meta: {
        title: '决策分析作业'
      },
      component: () => import('../views/jobs/pages/record/rule.vue')
    },
    {
      path: '/jobs/record/ind',
      meta: {
        title: '指标固化作业'
      },
      component: () => import('../views/jobs/pages/record/ind.vue')
    },
    {
      path: '/jobs/record/sub',
      meta: {
        title: '主题同步作业'
      },
      component: () => import('../views/jobs/pages/record/sub.vue')
    },
    {
      path: '/jobs/record/dim',
      meta: {
        title: '维表同步作业'
      },
      component: () => import('../views/jobs/pages/record/dim.vue')
    },
    {
      path: '/jobs/record/sys',
      meta: {
        title: '系统运维作业'
      },
      component: () => import('../views/jobs/pages/record/sys.vue')
    },
    {
      path: '/jobs/record/monitor',
      meta: {
        title: '财务监管作业'
      },
      component: () => import('../views/jobs/pages/record/monitor.vue')
    },
    {
      path: '/jobs/record/data',
      meta: {
        title: '数据管理作业'
      },
      component: () => import('../views/jobs/pages/record/data.vue')
    }
  ]
};

export default jobs;
